<template>
    <router-view />
</template>
<script>
export default {
    name: "Author"
}
</script>